import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, HostListener, Output, EventEmitter } from '@angular/core';
import { environment } from '@journal/env/environment';
import { Blog } from '@sparro/app/core/models/blog.model';
import { UserService } from '@sparro/app/core/api/user/user.service';
import { User } from '@sparro/app/core/models/user.model';

@Component({
  selector: 'uni-blog-featured-sidenav',
  templateUrl: './blog-featured-sidenav.component.html',
  styleUrls: ['./blog-featured-sidenav.component.scss']
})
export class BlogFeaturedSidenavComponent implements OnInit {

  @Input() feedFeatureBlogs: Blog[] = []

  feedBlog: Blog;
  user: User;
  sidenavScrollHeight: number = 0;

  @Input() self: boolean = false;
  @Input() showCardOptions: boolean = true;
  @Input() horizaontalView: boolean = false;
  @Output() sidenavFeaturedScrolled = new EventEmitter;
  @ViewChild('sidenavFeatured') sidenavRef: ElementRef;
  @ViewChild('widgetsContent') widgetsContent: ElementRef;

  constructor(
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.getAuthUser();
  }

  getAuthUser(): void {
    this.userService.userInitialized.subscribe(
      (initialized: boolean) => {
        if (initialized) {
          this.userService.user.subscribe(
            (user: User) => {
              this.user = user;
            });
        }
      });
  }

  ngAfterViewInit(){
    this.sidenavScrollHeight = this.sidenavRef.nativeElement.clientHeight + this.sidenavRef.nativeElement.offsetTop - 300;
  }

  // @HostListener('window:scroll', [])
  // onWindowScroll() {
  //   if (window.pageYOffset > this.sidenavScrollHeight) {
  //     this.sidenavFeaturedScrolled.emit({fixPosition: true, height: this.sidenavRef.nativeElement.clientHeight});
  //   }
  //   else {
  //     this.sidenavFeaturedScrolled.emit({fixPosition: false, height: this.sidenavRef.nativeElement.clientHeight});
  //   }
  // }

  onWheel(event: WheelEvent): void {
    this.widgetsContent.nativeElement.scrollLeft += event.deltaY;
    event.preventDefault();
}

  goToJournalSearch() {
    return `${environment.postUrl}search?page=1&user=team212&order=-created_at`;
  }

}
